import {
  reject,
  sortBy,
  set,
  map,
  flow,
  findIndex,
  flatMap,
  merge,
  assign,
} from 'lodash/fp';

export const mapWithIndexes = map.convert({ cap: false });

// remove item from items based on its id
export const removeId = (id, type) => {
  if (type) {
    return reject({ id, type });
  }
  return reject({ id });
};

// sort items by position
export const sortByPosition = sortBy('position');

// update item.position based on its index
const setPositionIteratee = (item, i) => set('position', i + 1, item);
export const resetPositions = mapWithIndexes(setPositionIteratee);

// sort items by item.postiion and update positions
export const sortAndUpdatePositions = flow(sortByPosition, resetPositions);

// removeId(id) then resetPositions
export const removeAndUpdatePositions = (id, type) =>
  flow(removeId(id, type), resetPositions);

export const getIds = map('id');

// update array item where that matches identity
export const updateItem = (
  collection,
  identity,
  destination,
  useMerge = true,
) => {
  collection = [...collection]; // immutability workaround
  const index = findIndex(identity)(collection);
  const assignor = useMerge ? merge : assign;
  collection.splice(index, 1, assignor(collection[index])(destination));
  return collection;
};

export const reorderItem = (position, newPosition) => collection => {
  const elements = [...collection];
  elements.splice(newPosition - 1, 0, elements.splice(position - 1, 1)[0]);
  return resetPositions(elements);
};

export const flattenByKey = key => collection => {
  const flatten = flatMap(i => (i[key] ? flatten(i[key]) : i));
  return flatten(collection);
};

export const hasOwnProperty = (object, property) =>
  object && Object.prototype.hasOwnProperty.call(object, property);
